<template>
  <div :class="{ 'checkbox-group-disabled': disabled, 'checkbox-group': true }">
    <div class="checkbox-title" v-if="title">
      {{ title }}
    </div>
    <b-form-group
      :class="['custom-checkbox-group', errorText ? 'checkbox-error' : '']"
    >
      <b-form-checkbox-group
        :id="id"
        v-model="selected"
        :options="options"
        :disabled="disabled"
        name="checkbox"
      ></b-form-checkbox-group>
    </b-form-group>
    <div class="error" v-if="errorText">{{ errorText }}</div>
    <!-- <div>內{{selected}}</div> -->
  </div>
</template>

<script>
import Vue from 'vue';
import { BFormGroup, BFormCheckbox, BFormCheckboxGroup } from 'bootstrap-vue';
Vue.component('b-form-group', BFormGroup);
Vue.component('b-form-checkbox', BFormCheckbox);
Vue.component('b-form-checkbox-group', BFormCheckboxGroup);

export default {
  name: 'CheckboxGroup',
  props: {
    id: {
      type: String,
    },
    title: {
      type: String,
    },
    value: {
      type: Array,
    },
    options: {
      type: Array,
    },
    errorText: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {},
  watch: {
    selected(newVal) {
      this.$emit('input', newVal);
    },
    value() {
      this.selected = this.value;
    },
  },
  data() {
    return {
      selected: this.value,
    };
  },
};
</script>

<style>
.checkbox-group {
  min-height: 65px;
}

.checkbox-group-disabled > div:first-child {
  color: gray;
}

.custom-control {
  width: fit-content;
  cursor: pointer;
  padding: 0;
}

.custom-control-label,
.custom-control-label span,
.custom-control-label::after {
  cursor: pointer;
  font-size: 16px;
}

.checkbox-group-disabled .custom-control {
  cursor: default;
}

.checkbox-group-disabled .custom-control-label,
.checkbox-group-disabled .custom-control-label span,
.checkbox-group-disabled .custom-control-label::after {
  cursor: default;
}

.custom-control-label > span {
  padding: 0 0 0 1.5rem;
}

.custom-control-label::before,
.custom-control-label::after {
  left: 0;
}

.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #b18147;
}
.custom-checkbox .custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0px #fff, 0 0 0 0.2rem #fff;
  border-color: #68635c;
}
.custom-checkbox .custom-control-input:defined ~ .custom-control-label::before {
  border-color: #b18147;
}
.custom-checkbox
  .custom-control-input:disabled
  ~ .custom-control-label::before {
  border-color: lightgray;
}
.custom-checkbox
  .custom-control-input:disabled:checked
  ~ .custom-control-label::before {
  background-color: #b89c7b;
}

.custom-checkbox
  .custom-control-input:active:hover
  ~ .custom-control-label::before {
  background-color: #fff;
  border-color: #b18147;
}

.checkbox-title {
  color: #b18147;
  margin-bottom: 10px;
  font-size: 12px;
  font-weight: bold;
}

.custom-checkbox-group {
  margin: 0px;
  padding-left: 10px;
}

.checkbox-error {
  border-color: #c34040 !important;
  border: 1px solid rgba(70, 70, 70, 0.8);
  border-radius: 4px;
}
</style>
